import styled, { css } from 'styled-components';
import { colorVariables, mediaTemplates } from 'theme/variables';

export const VideoInfoStyled = styled.div`
  position: relative;
  display: flex;
  flex-grow: 1;
  flex-shrink: 0;
`;

export const LoginButtonWrap = styled.div`
  margin-bottom: 1px;
`;

export const PosterWrap = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: calc(100vh / 4.23 * 3);
  max-width: 42%;
  min-width: 30%;

  ${mediaTemplates.xxs} {
    display: none;
  }
`;

export const VideoInfoWrapper = styled.div`
  position: relative;
  min-width: 58%;
  max-width: 70%;
  min-height: 100%;
  width: calc(100% - (100vh / 4.23 * 3));
  padding-top: 18px;
  padding-right: 20px;
  padding-bottom: 57px;
  padding-left: 20px;
  background-color: rgba(255, 255, 255, 0.95);
  display: flex;
  flex-direction: column;

  ${mediaTemplates.xxs} {
    width: 100%;
    max-width: none;
    padding-bottom: 60px;
  }

  ${mediaTemplates.xs} {
    padding-bottom: 60px;
  }

  ${mediaTemplates.m} {
    padding-top: 34px;
    padding-right: 40px;
    padding-bottom: 37px;
    padding-left: 40px;
  }
`;

export const TopWrap = styled.div`
  position: relative;
  margin-bottom: 17px;

  ${mediaTemplates.l} {
    margin-bottom: 25px;
  }
`;

export const Rating = styled.div`
  position: relative;
  display: none;
  margin-top: 20px;

  ${mediaTemplates.xxs} {
    display: flex;
    margin-bottom: 20px;
  }

  ${mediaTemplates.m} {
    display: flex;
  }

  ${mediaTemplates.l} {
    margin-top: 24px;
  }
`;

export const RatingLabelWrap = styled.div`
  position: relative;

  &:nth-child(2) {
    margin-left: 20px;
  }
`;

export const ButtonWrapper = styled.div`
  position: relative;
  display: flex;
  margin-top: 22px;

  ${mediaTemplates.xs} {
    margin-top: 10px;
  }

  ${mediaTemplates.l} {
    margin-top: 30px;
  }
`;

export const BottomControl = styled.div`
  position: absolute;
  left: 20px;
  bottom: 17px;
  right: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${mediaTemplates.m} {
    bottom: 37px;
    left: 40px;
    right: 40px;
  }
`;

export const LinkToSeasons = styled.div`
  position: relative;

  ${mediaTemplates.l} {
    margin-top: 3px;

    svg {
      height: 19px;
      width: 19px;
    }
  }
`;

export const SecondTrailerSeparator = styled.div`
  width: 1px;
  background-color: ${colorVariables.white_lightgainsboro};
  margin-left: 25px;
  margin-right: 25px;
`;

export const SecondTrailerButton = styled.div`
  display: flex;
  align-items: center;
`;

export const LinkWrap = styled.div`
  transition: all 0.25s ease-in-out;

  ${({ clickable }) =>
    !clickable &&
    css`
      cursor: default;
      pointer-events: none;
    `} &:hover {
    opacity: 0.65;
  }
`;
